<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Cliente
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="onNuevo" v-html="'Nuevo'" />
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <ModalClienteComponent :open="obModal.open" 
                                               :obModal="obModal"
                                               :listGeneral="listGeneral"
                                               :parametros="parametros"
                        />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo Persona *" color="textbox" v-model="obSearch.idTipoPersona"
                            item-value="idTipoPersona" item-text="tipoPersona"
                            :items="listGeneral.listTipoPersona" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo Inscripción " color="textbox" v-model="obSearch.idTipoInscripcion"
                            item-value="idTipoInscripcion" item-text="tipoInscripcion"
                            :items="listGeneral.listTipoInscripcion" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estados " color="textbox" v-model="obSearch.idEstado"
                            item-value="id_estado" item-text="nombre_estado"
                            :items="listGeneral.listEstado" outlined dense />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12" class="text-right">
                        <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                                <v-btn fab dark small color="primary" @click="onListar" v-on="on" :disabled="disabled">
                                    <v-icon dark>search</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="edit(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="obSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'ClienteView',
        components:{
            ModalClienteComponent: () => import('@/components/catalogo/ModalClienteComponent.vue')
        },
        data: () => ({
            obSearch: {
                search: '',
                idTipoPersona: null,
                idTipoInscripcion: null,
                idEstado: null
            },
            obModal: {
                open: false,
                titulo: 'Nuevo Cliente'
            },
            disabled:false,
            listGeneral:{},
            parametros:{}
        }),
        created(){
            var error = 'E';
            axios.post(`${BASE_URI}administrador/cliente/cargaGeneral`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);

                        this.obSearch.idTipoPersona     = _.toString(this.parametros.id_tipo_persona_natural);
                        this.obSearch.idTipoInscripcion = _.toString(this.parametros.id_tipo_inscripcion_wizard);
                        this.obSearch.idEstado          = _.toString(this.parametros.id_estado_default);

                        return this.onListar('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        methods: {
            onNuevo() {
                this.obModal = {
                    open: true,
                    titulo: 'Nuevo Cliente',
                    idTipoPersona: _.toString(this.parametros.id_tipo_persona_natural),
                    idTipoDocumento: _.toString(this.parametros.id_tipo_doc_cedula),
                    fotografia: '',
                    firma:'',
                    idEstado: _.toString(this.parametros.id_estado_default)
                }
            },
            onClose() {
                this.obModal = {
                    open: false,
                    titulo: 'Nuevo Cliente'
                }
            },
            edit(v){
                v.fotografia = _.size(v.fotografia) > 0 ?  `data:image/png;base64,${v.fotografia}` : '';
                v.firma = _.size(v.firma) > 0 ?  `data:image/png;base64,${v.firma}` : '';
                this.$set(this,'obModal',_.merge({},v,{open:true,titulo:'Editar Cliente'}));
            },
            onListar(event){
                if(!_.isUndefined(event)){
                    this.disabled = true;
                    this.listGeneral.detalle = [];
                    var ob = {
                        opcion:'LISTAR',
                        idTipoPersona: _.toNumber(this.obSearch.idTipoPersona) == 0 ? null : this.obSearch.idTipoPersona,
                        idTipoInscripcion: _.toNumber(this.obSearch.idTipoInscripcion) == 0 ? null : this.obSearch.idTipoInscripcion,
                        idEstado: _.toNumber(this.obSearch.idEstado) == 0 ? null : this.obSearch.idEstado
                    }
                    var error = 'E';
                    axios.post(`${BASE_URI}administrador/cliente/listarDetalle`,ob)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                this.listGeneral.detalle = r.data.data;
                                this.disabled = false;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                            this.disabled = false;
                        });

                }
            }
        },
        provide(){
            return{
                onClose:this.onClose
            }
        }
    }
</script>